/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/**
 * Helper function that watches the authenticate state, then applies it
 * as a boolean (authenticated) as well as attaches the userinfo data.
 */
import Cookies from 'js-cookie'
import jwtDecode from 'jwt-decode'
import { isChineseFun } from '@/utils/common'
const redirectURL = window.location.origin + (process.env.PUBLIC_URL || '') + '/login'

const getAuthenticationStatus = () => {
  const shvOauthToken = Cookies.get('nfc-oauth-token') // get SHV generated token for external users
  if (!shvOauthToken) {
    return { authenticated: false, reason: 'missing' }
  }

  try {
    const account = jwtDecode(shvOauthToken)
    if (!account || !account.exp) {
      return { authenticated: false, reason: 'invalid' }
    }

    if (account.exp * 1000 <= Date.now()) {
      return { authenticated: false, reason: 'expired' }
    }

    return { authenticated: true, reason: '', account }
  } catch (err) {
    // Invalid JWT token
    console.log(err)
    return { authenticated: false, reason: 'invalid' }
  }
}

async function checkAuthentication() {
  const { authenticated } = getAuthenticationStatus()
  if (authenticated !== this.state.authenticated) {
    this.setState({ authenticated })
  }
}

const clearAuthentication = () => {
  Cookies.remove('nfc-oauth-token')
  // localStorage.clear()
  localStorage.removeItem('permissions')
  localStorage.removeItem('userName')
  localStorage.removeItem('roles')
  localStorage.removeItem('account')
  localStorage.removeItem('workstation')
  localStorage.removeItem('categorys')
  localStorage.removeItem('mac')
  localStorage.removeItem('permissionsCompleteInfo')
  localStorage.removeItem('nfcOauthIdToken')
}

// authType: 0,1; 0 indicate internal user, 1 indicate external user;
const generateAuthHeader = async () => {
  let accessToken = Cookies.get('nfc-oauth-token') // get SHV generated token for external users
  return {
    Authorization: accessToken || '',
    username: localStorage.getItem('account'),
    isChinese: JSON.stringify(isChineseFun().isChinese)
  }
}

/* eslint-disable import/prefer-default-export */
export { generateAuthHeader, checkAuthentication, clearAuthentication, redirectURL, getAuthenticationStatus }
